import Config from '@/config/app.js'
export function setPageJsBridgeConfig(NodePageConfig) {

  NodePageConfig.demo.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '',
    hasReturnBtn: true,
    returnBtnType: 'gradual',
    hasShareBtn: true,
    shareBtnInfo: {
      shareTitle: '',
      shareUrl: Config.sharePageUrl + '/share.html?id=' + window.location.search,
      shareContent: 'IO在线 护助未来',
      shareImgUrl: Config.shareLogo,
      sharePlatform: ['WEIXIN', 'WEIXIN_CIRCLE', 'QQ', 'SINA']
    }
  };
  NodePageConfig.courseDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '课程介绍',
    hasReturnBtn: true,
    returnBtnType: 'gradual',
  };
  NodePageConfig.agreementUser.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '用户协议',
    hasReturnBtn: true,
    returnBtnType: 'direct',//协议直接返回，有可能是4.0跳过来的。
  };
  NodePageConfig.agreementPrivacy.bridgeConfig = {
    hasTitle: true,
    title: '隐私协议',
    hasReturnBtn: true,
    returnBtnType: 'direct',//协议直接返回
  };
  NodePageConfig.agreementStudioMembers.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '工作室成员协议',
    hasReturnBtn: true,
    returnBtnType: 'gradual',
  };
  NodePageConfig.agreementStudioManager.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '护士工作室负责人服务协议',
    hasReturnBtn: true,
    returnBtnType: 'gradual',
  };
  NodePageConfig.serviceDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '服务详情',
    hasReturnBtn: true,
    hasCustomerServiceBtn: true,
    returnBtnType: 'gradual',
  };
  NodePageConfig.applyStudio.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '申请工作室',
    hasReturnBtn: true, // 返回按钮
    // hasCustomerServiceBtn:true, // 客服按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.previewStudio.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '预览工作室',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.applyStudioSuccess.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '提交申请工作室成功',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.exitStudioSuccess.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '退出工作室',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };

  NodePageConfig.studioDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '工作室详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.sendOrder.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '工作室发单',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.previewOrder.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '工作室发单预览',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };

  NodePageConfig.sendOrderSuccess.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '发单成功',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  // 加标识
  NodePageConfig.examError.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };

  NodePageConfig.examRules.bridgeConfig = {//配置到护士加app的配置
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.studyData.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '学习数据',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.orderDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '订单详情',
    hasReturnBtn: true, // 返回按钮
    // hasMessageBtn: true, // 消息按钮
    hasCustomerServiceBtn: true, // 客服按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.orderTransition.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '订单详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: Config.sharePageUrl + 'findReceivedOrders.html', // 返回按钮类型
  };
  NodePageConfig.findReceivedOrders.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '订单详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.searchStudio.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '搜索工作室列表',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.joinStudio.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '加入工作室',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.studyPlan.bridgeConfig = {//配置到护士加app的配置
    // hasTitle:true,
    // title:'学习计划 测试',
    // hasReturnBtn:true, // 返回按钮
    // returnBtnType:'gradual', // 返回按钮类型
    hiddenNavBar: true, // 隐藏客户端头部
    // page_hidden_nav_bar: 1
  };
  NodePageConfig.studyPlanList.bridgeConfig = {//配置到护士加app的配置
    // hasTitle:true,
    // title:'学习计划列表',
    // hasReturnBtn:true, // 返回按钮
    // returnBtnType:'gradual', // 返回按钮类型
    hiddenNavBar: true, // 隐藏客户端头部
    // page_hidden_nav_bar: 1
  };
  NodePageConfig.joinStudioSuccess.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '提交成功',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.authDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '认证详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.baseAuth.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.authMemberDetails.bridgeConfig = {//配置到护士加app的配置
    hasTitle: true,
    title: '查看成员认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.submitReviewSuccess.bridgeConfig = {
    hasTitle: true,// 此页面共用了，修改这里请注意
    title: '提交申请成功',// 此页面共用了，修改这里请注意
    hasReturnBtn: true, // 此页面共用了，修改这里请注意
    returnBtnType: 'direct', // 此页面共用了，修改这里请注意
  };
  NodePageConfig.articleDetails.bridgeConfig = {//配置到护士加app的配置
  };
  NodePageConfig.topicWrong.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.topicExam.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.topicExamResult.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.topicExamDetails.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.topicStudy.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.topicStudyResult.bridgeConfig = {
    hiddenNavBar: true, // 隐藏客户端头部
  };
  NodePageConfig.certSpecial.bridgeConfig = {
    hasTitle: true,
    title: '专业认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.internetCertificate.bridgeConfig = {
    hasTitle: true,
    title: '我的证书',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };

  NodePageConfig.insurance.bridgeConfig = {
    hasTitle: true,
    title: '我的保险',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.nursingEvaluation.bridgeConfig = { //  护理评估
    hasTitle: true,
    title: '护理评估',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.nursingEvaluationDetails.bridgeConfig = { //  护理评估
    hasTitle: true,
    title: '护理评估详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.visitDetails.bridgeConfig = { //  客服服务确认详情
    hasTitle: true,
    title: '客服服务确认详情',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.serviceProcess.bridgeConfig = { //  客服服务确认详情
    hasTitle: true,
    title: '查看服务流程',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.unableToLogin.bridgeConfig = {
    hasTitle: true,
    title: '申请更换手机号',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.bindingCard.bridgeConfig = {
    hasTitle: true,
    title: '激活学习卡',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'gradual', // 返回按钮类型
  };
  NodePageConfig.realName.bridgeConfig = {
    hasTitle: true,
    title: '实名认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.realNameSuccess.bridgeConfig = {
    hasTitle: true,
    title: '实名认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
  NodePageConfig.realNameError.bridgeConfig = {
    hasTitle: true,
    title: '实名认证',
    hasReturnBtn: true, // 返回按钮
    returnBtnType: 'direct', // 返回按钮类型
  };
}
